
export default function HiddenWebFormComponent(props) {

    return null; // There is no need to produce actual input type=hidden, because it won't be modified anyway (value is just stored in DSL)
}

HiddenWebFormComponent.propTypes = {}

HiddenWebFormComponent.defaultProps = {}